import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { OptinRemindComponent } from './optin-remind/optin-remind.component';
import { SignupComponent } from './signup/signup.component';
import { KazaComponent } from './kaza/kaza.component';
import { TagsComponent } from './tags/tags.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { AuthComponent } from './auth.component';
import { EmailCheckComponent } from "./email-check/email-check.component";
import { ConstructionDateComponent } from 'src/app/modules/auth/construction-date/construction-date.component';
import { OAuthGuard } from 'src/app/shared/guards/OAuthGuard';

export const routes: Routes = [
  // AuthComponent with size 'md'
  /*{
    path: '',
    component: AuthComponent,
    canActivateChild: [OAuthGuard],
    data: {
      modalSize: 'md'
    },
    children: [
      {
        path: 'email-check',
        component: EmailCheckComponent,
        pathMatch: 'full',
      },
    ]
  }*/,
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        canActivate: [OAuthGuard],
        path: 'construction-date',
        component: ConstructionDateComponent,
        pathMatch: 'full'
      },
      {
        canActivate: [OAuthGuard],
        path: 'kaza',
        component: KazaComponent,
        pathMatch: 'full'
      },
      {
        path: 'login',
        component: LoginComponent,
        pathMatch: 'full'
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        pathMatch: 'full'
      },
      {
        canActivate: [OAuthGuard],
        path: 'profil',
        component: SignupComponent,
        pathMatch: 'full'
      },
      {
        path: 'signup',
        component: SignupComponent,
        pathMatch: 'full'
      },
      {
        path: 'signup/pro',
        component: SignupComponent,
        pathMatch: 'full'
      },
      {
        canActivate: [OAuthGuard],
        path: 'tags/:step',
        component: TagsComponent,
        pathMatch: 'full'
      },
      {
        canActivate: [OAuthGuard],
        path: 'optin-remind',
        component: OptinRemindComponent,
        pathMatch: 'full'
      },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    LocalizeRouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
    LocalizeRouterModule
  ]
})
export class AuthRoutingModule {
}


